import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { api } from '@/data/api';

export interface RequestConfig<TData = any> extends AxiosRequestConfig<TData> {}

export interface ResponseConfig<TData = any> extends AxiosResponse<TData> {}

export interface ResponseErrorConfig<TError = any> {
  response?: AxiosResponse<TError>;
  message: string;
  status?: number;
}

const fetch = async <TData = any, TError = any, TVariables = any>(
  config: AxiosRequestConfig<TVariables>,
): Promise<ResponseConfig<TData>> => {
  return api.request<TData>(config);
};

export default fetch;
